import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../../services/userService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-reset',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.css'
})
export class PasswordResetComponent {
  constructor(private formBulder: FormBuilder, private userService: UserService, private router: Router) { }
  resetForm = new FormGroup({
    Email: new FormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])
  });

  //ngOnInit() {
  //  this.buildForm()
  //}

  //buildForm() {
  //  this.resetForm = this.formBulder.group({
  //    Email: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')]]
  //  });
  //}

  resetPassword(resetData: any) {
    this.userService.resetPassword(resetData.Email).subscribe(data => {
      //if (data) {
      //  if (!this.authService.IsAuthenticated()) {
      //    this.authService.authenticate();
      //  }
      //}
      this.router.navigate(['password-reset-result']);
    });
  }
}
